import { useState } from 'react';
import { heroStats, hotTags } from '@/mocks/gua88-site';

export default function Hero({ onSearch }: { onSearch: (q: string) => void }) {
  const [q, setQ] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(q.trim());
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* subtle top ornament */}
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-accent-100/60 blur-2xl"></div>
      <div className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-primary-100/50 blur-2xl"></div>

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 pb-14 pt-28 md:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:pt-36">
        {/* left copy */}
        <div className="relative">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            蹲后续专区 · 持续更新中
          </div>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-[1.12]">
            88余波未平
            <span className="relative mx-2 inline-block text-primary-500">
              续集
              <span className="absolute inset-x-0 -bottom-1 h-2 -rotate-1 bg-accent-200/70"></span>
            </span>
            正在更新
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            正片结束不等于瓜停。这里持续整理 88 事件的最新进展：续集爆料、当事人回应、新线索与事件走向。
            蹲后续、追新料的朋友都在这里，第一时间掌握完整脉络。
          </p>

          {/* search */}
          <form
            onSubmit={submit}
            className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:border sm:border-background-300 sm:bg-background-50 sm:p-1.5"
          >
            <div className="relative flex items-center">
              <i className="ri-search-line absolute left-4 text-foreground-500"></i>
              <input
                type="text"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="搜索续集爆料、当事人回应、新线索…"
                className="w-full rounded-full border border-background-300 bg-background-100/60 py-3 pl-11 pr-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-300 sm:border-0 sm:bg-transparent sm:py-2.5"
              />
            </div>
            <button
              type="submit"
              className="shrink-0 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:py-2.5"
            >
              搜索瓜料
            </button>
          </form>

          {/* hot tags */}
          <div className="mt-4 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500">热门标签</span>
            {hotTags.map((t) => (
              <a
                key={t}
                href="#feed"
                className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                #{t}
              </a>
            ))}
          </div>

          {/* stats */}
          <dl className="mt-8 grid grid-cols-4 divide-x divide-background-200 border-t border-background-200 pt-5">
            {heroStats.map((s) => (
              <div key={s.label} className="px-3 first:pl-0 last:pr-0">
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-display text-2xl leading-none text-foreground-950 md:text-3xl">
                  {s.value}
                </dd>
                <dd className="mt-1.5 text-xs text-foreground-600 md:text-sm">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* right editorial image card */}
        <div className="relative hidden lg:block">
          <div className="absolute -top-4 right-6 z-10 rotate-2 rounded-md bg-accent-500 px-3 py-2 font-heading text-sm font-bold text-background-50 shadow-soft">
            今日新料 +1
          </div>
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20a%20stack%20of%20cozy%20newspaper%20pages%20with%20a%20half%20watermelon%20on%20top%20and%20a%20small%20megaphone%20beside%20it%2C%20floating%20exclamation%20marks%20and%20light%20rays%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20palette%2C%20soft%20shadows%2C%20cozy%20vector%20art%20style%2C%20consistent%20warm%20tones%2C%20clean%20composition&width=1000&height=750&seq=gua-hero-visual-01&orientation=landscape"
                alt="88吃瓜后续专区编辑部插画"
                title="88吃瓜后续专区"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/55 to-black/0 p-5 pt-12">
              <p className="font-heading text-base font-bold leading-snug text-background-50">
                正片落幕，瓜没停。
                <br />
                蹲后续的，都在这。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}